// NOTE: import this file to enable why-did-you-render logging - import './wdyr'
import App from './App'
import withProvider from './withProvider'

export { App, withProvider }
export default withProvider(App)
